import { SystemRole } from '../Enums/system-role.enum';
import { StatusTone } from '../Modules/Shared/Types/status-tone.type';

export const ROLE_RECONCILIATION_RUN = SystemRole.BACKOFFICE_BILLING_ADMIN;

export const SEVERITY_LABEL: Readonly<Record<string, string>> = {
  in_sync: 'backoffice.enums.reconciliation_severity.in_sync',
  drift: 'backoffice.enums.reconciliation_severity.drift',
  critical: 'backoffice.enums.reconciliation_severity.critical',
};

export const SEVERITY_TONE: Readonly<Record<string, StatusTone>> = {
  in_sync: 'positive',
  drift: 'warning',
  critical: 'danger',
};

export const SHAPE_LABEL: Readonly<Record<string, string>> = {
  more_licences_than_billed: 'backoffice.enums.reconciliation_shape.more_licences_than_billed',
  more_billed_than_issued: 'backoffice.enums.reconciliation_shape.more_billed_than_issued',
  half_state: 'backoffice.enums.reconciliation_shape.half_state',
  cancellation_not_applied: 'backoffice.enums.reconciliation_shape.cancellation_not_applied',
  local_mirror_stale: 'backoffice.enums.reconciliation_shape.local_mirror_stale',
  not_owned: 'backoffice.enums.reconciliation_shape.not_owned',
  no_stripe_subscription: 'backoffice.enums.reconciliation_shape.no_stripe_subscription',
  stripe_unreadable: 'backoffice.enums.reconciliation_shape.stripe_unreadable',
};

export const SHAPE_EXPLANATION: Readonly<Record<string, string>> = {
  more_licences_than_billed:
    'backoffice.enums.reconciliation_shape_explanation.more_licences_than_billed',
  more_billed_than_issued:
    'backoffice.enums.reconciliation_shape_explanation.more_billed_than_issued',
  half_state: 'backoffice.enums.reconciliation_shape_explanation.half_state',
  cancellation_not_applied:
    'backoffice.enums.reconciliation_shape_explanation.cancellation_not_applied',
  local_mirror_stale: 'backoffice.enums.reconciliation_shape_explanation.local_mirror_stale',
  not_owned: 'backoffice.enums.reconciliation_shape_explanation.not_owned',
  no_stripe_subscription:
    'backoffice.enums.reconciliation_shape_explanation.no_stripe_subscription',
  stripe_unreadable: 'backoffice.enums.reconciliation_shape_explanation.stripe_unreadable',
};

export const ALERT_OUTCOME_LABEL: Readonly<Record<string, string>> = {
  sent: 'backoffice.enums.reconciliation_alert_outcome.sent',
  suppressed: 'backoffice.enums.reconciliation_alert_outcome.suppressed',
  muted: 'backoffice.enums.reconciliation_alert_outcome.muted',
  no_recipient: 'backoffice.enums.reconciliation_alert_outcome.no_recipient',
  failed: 'backoffice.enums.reconciliation_alert_outcome.failed',
};

export const RECONCILIATION_RAN_MESSAGE = 'backoffice.reconciliation.run.done';
